module.exports = __webpack_public_path__ + "static/1-c507d5076c1b47e7c14febb835fb028d.jpeg";